<template>
<div>

    <!-- SIDEBAR STUFF -->
    <div class="layout-wrapper d-lg-flex">
        <div class="side-menu flex-lg-column mr-lg-1">
            <div class="navbar-brand-box">
                <router-link to="/" tag="a" class="logo logo-dark">
                    <span class="logo-sm">
                      <img src="@/assets/images/logo.svg" alt height="30" />
                    </span>
                </router-link>

                <router-link tag="a" to="/" class="logo logo-light">
                    <span class="logo-sm">
                      <img src="@/assets/images/logo.svg" alt height="30" />
                    </span>
                </router-link>
            </div>
        </div>

        <div class="chat-leftsidebar mr-lg-1">
            <div class="tab-content">
                <div class="px-2 py-4 text-center font-size-16">
                    <span class="d-inline-block mr-1">
                        <font-awesome-icon :icon="['fas', 'comments']" />
                    </span>
                    <h5 class="d-inline"> Recent conversations</h5>
                </div>
                <div>
                    <div
                        class="tab-pane fade show active"
                        id="pills-chat"
                        role="tabpanel"
                        aria-labelledby="pills-chat-tab">
                        <div class="chat-message-list">
                            <convo-list
                                :convos="convoList"
                                :activeConvo="activeConversation"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ACTUAL CHAT -->
        <div class="user-chat w-100 overflow-hidden">
            <div class="d-lg-flex">
                <div class="w-100 overflow-hidden position-relative">

                    <!-- TOP HEADER PART -->
                    <div class="p-3 p-lg-4 border-bottom">
                        <div class="row align-items-center">

                            <!--LEFT SIDE -->
                            <div class="col-sm-4 col-8">
                                <div class="media align-items-center">
                                    <div class="mr-3">
                                        <img
                                            :src="
                                          room.profile
                                            ? room.profile
                                            : require('@/assets/images/users/avatar-bot.jpg')
                                        "
                                            class="rounded-circle avatar-xs"
                                            alt
                                        />
                                    </div>

                                    <div class="media-body overflow-hidden">
                                        <h5 class="font-size-16 mb-0 text-truncate">
                                            <a href="javascript:void(0);" class="text-reset user-profile-show">{{
                                                    $t(room.name) ? $t(room.name) : "BetBot"
                                                }}</a>
                                            <i
                                                class="ri-record-circle-fill font-size-10 text-success d-inline-block ml-1"
                                            ></i>
                                        </h5>
                                    </div>

                                </div>
                            </div>


                            <!--RIGHT SIDE -->
                            <div class="col-sm-8 col-4">
                                <ul class="list-inline user-chat-nav text-right mb-0">
                                    <li class="list-inline-item">
                                        <b-dropdown
                                            toggle-class="nav-btn"
                                            variant="white"
                                            menu-class="dropdown-menu-md p-0"
                                            right
                                        >
                                            <template v-slot:button-content>
                                                <i class="ri-search-line"></i>
                                            </template>
                                            <div class="search-box p-2">
                                                <input
                                                    type="text"
                                                    class="form-control bg-light border-0"
                                                    placeholder="Search.."
                                                />
                                            </div>
                                        </b-dropdown>
                                    </li>
                                    <li class="list-inline-item d-none d-lg-inline-block">
                                        <button
                                            type="button"
                                            class="btn nav-btn user-profile-show"
                                            @click="toggleProfile()"
                                        >
                                            <i class="ri-user-2-line"></i>
                                        </button>
                                    </li>

                                    <li class="list-inline-item">
                                        <b-dropdown toggle-class="nav-btn" variant="white" right>
                                            <template v-slot:button-content>
                                                <i class="ri-more-fill"></i>
                                            </template>
                                            <b-dropdown-item
                                                class="d-block d-lg-none user-profile-show"
                                                href="javascript:void(0);"
                                            >
                                                View profile
                                                <i class="ri-user-2-line float-right text-muted"></i>
                                            </b-dropdown-item>
                                            <b-dropdown-item>
                                                Delete
                                                <i class="ri-delete-bin-line float-right text-muted"></i>
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>

                    <!-- CHAT CONTENT -->
                    <simplebar
                        class="chat-conversation p-3 p-lg-4"
                        id="containerElement"
                        ref="current"
                    >
                        <transition-group name="fade">
                            <div v-for="(message, index) in messages" :key="`single-message-`+index">
                                <message
                                    :currentUserId="currentUserId"
                                    :message="message"
                                    :messages="messages"
                                    :editedMessage="editedMessage"
                                    :messageActions="messageActions"
                                    :roomUsers="room.users"
                                    :textMessages="t"
                                    :roomFooterRef="$refs.roomFooter"
                                    :newMessages="newMessages"
                                    :textFormatting="false"
                                    :hideOptions="hideOptions"

                                    @messageActionHandler="messageActionHandler"
                                    @addNewMessage="addNewMessage"
                                    @hideOptions="hideOptions = $event"
                                ></message>
                            </div>
                        </transition-group>

                    </simplebar>

                    <!-- EDITED MESSAGE -->
                    <div class="d-block w-100">
                        <transition name="slide-up">
                            <div v-if="messageReply" class="reply-container">
                                <div class="reply-box bg-light">
                                    <div class="reply-info">
                                        <div class="reply-username">{{ messageReply.username }}</div>
                                        <div class="reply-content">{{ messageReply.content }}</div>
                                    </div>
                                </div>

                                <div class="icon-reply">
                                    <div class="svg-button" @click="resetMessage">
                                        <i class="ri-close-line"></i>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <div class="box-footer chat-input-section p-3 p-lg-4 border-top mb-0">
                            <textarea
                                ref="roomTextarea"
                                :placeholder="`Enter your message here`"
                                :style="{ 'min-height': `20px`,'padding-left': `12px`}"
                                class="form-control form-control-lg bg-light border-light rounded"
                                v-model="message"
                                @input="onChangeInput"
                                @keydown.esc="resetMessage"
                                @keyup.enter.exact.prevent="sendMessage"
                            ></textarea>

                            <div class="icon-textarea">
                                <div
                                    class="svg-button"
                                    v-if="editedMessage._id"
                                    @click="resetMessage"
                                >
                                    <!-- <svg-icon name="close-outline" /> -->
                                </div>

                                <div>
                                    <button
                                        type="submit"
                                        class="btn btn-primary font-size-16 btn-lg chat-send"
                                        @click="sendMessage"

                                        :class="{ 'send-disabled': inputDisabled }"
                                    >
                                        <i
                                            class="ri-send-plane-2-fill"
                                            :param="inputDisabled ? 'disabled' : ''"
                                        ></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    </div>


</div>



</template>

<script>
import { required } from 'vuelidate/lib/validators';
import Message from "@/views/components/message.vue";
import locales from "@/locales/locales";
import convoList from "@/views/components/convoList.vue";

import store from "@/store";

import simplebar from "simplebar-vue";
import vClickOutside from "v-click-outside";

export default {
    components: {
        Message,
        convoList,
        simplebar
    },
    directives: {
        clickOutside: vClickOutside.directive,
    },
    mounted() {
        // this.$nextTick(() => {
        //     this.scrollToBottom();
        // });
        console.log("mounted", store);
        this.fetchConversations();
    },
    data() {
        return {
            // convoList: [
            //     {
            //         id: 12,
            //         name: 'How can we get this done?',
            //     },
            //     {
            //         id: 10,
            //         name: 'Is there a bonus system for new...',
            //     },
            // ],
            messageReply: null,
            activeConversation: null,

            currentUserId: 2,

            messages: [
                {
                    id: 1,
                    name: 'BetBot',
                    image: require('@/assets/images/users/avatar-bot.jpg'),
                    content: `Good morning! How can I help you today? What would you like to know?`,
                    time: '10:00',
                    is_user: false
                },

            ],
            chatMemberList: [
                {
                    id: 1,
                    name: 'chat.tabs.chats.recent.userslist.user1.name',
                    profile: require('@/assets/images/users/avatar-2.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user1.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user1.time'
                },
                {
                    id: 2,
                    name: 'chat.tabs.chats.recent.userslist.user2.name',
                    profile: require('@/assets/images/users/avatar-3.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user2.message",
                    status: 'away',
                    time: 'chat.tabs.chats.recent.userslist.user2.time'
                },
                {
                    id: 3,
                    name: 'chat.tabs.chats.recent.userslist.user3.name',
                    message: "chat.tabs.chats.recent.userslist.user3.message",
                    time: 'chat.tabs.chats.recent.userslist.user3.time'
                },
                {
                    id: 4,
                    name: 'chat.tabs.chats.recent.userslist.user4.name',
                    profile: require('@/assets/images/users/avatar-bot.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user4.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user4.time'
                },
                {
                    id: 5,
                    name: 'chat.tabs.chats.recent.userslist.user5.name',
                    message: "chat.tabs.chats.recent.userslist.user5.message",
                    time: 'chat.tabs.chats.recent.userslist.user5.time'
                },
                {
                    id: 6,
                    name: 'chat.tabs.chats.recent.userslist.user6.name',
                    profile: require('@/assets/images/users/avatar-6.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user6.message",
                    status: 'away',
                    time: 'chat.tabs.chats.recent.userslist.user6.time'
                },
                {
                    id: 7,
                    name: 'chat.tabs.chats.recent.userslist.user7.name',
                    message: "chat.tabs.chats.recent.userslist.user7.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user7.time'
                },
                {
                    id: 8,
                    name: 'chat.tabs.chats.recent.userslist.user8.name',
                    message: "chat.tabs.chats.recent.userslist.user8.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user8.time'
                },
                {
                    id: 9,
                    name: 'chat.tabs.chats.recent.userslist.user9.name',
                    profile: require('@/assets/images/users/avatar-7.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user9.message",
                    status: 'away',
                    time: 'chat.tabs.chats.recent.userslist.user9.time'
                },
                {
                    id: 10,
                    name: 'chat.tabs.chats.recent.userslist.user10.name',
                    message: "chat.tabs.chats.recent.userslist.user10.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user10.time'
                },
                {
                    id: 11,
                    name: 'chat.tabs.chats.recent.userslist.user11.name',
                    profile: require('@/assets/images/users/avatar-8.jpg'),
                    message: "chat.tabs.chats.recent.userslist.user11.message",
                    status: 'away',
                    time: 'chat.tabs.chats.recent.userslist.user11.time'
                },
                {
                    id: 12,
                    name: 'chat.tabs.chats.recent.userslist.user12.name',
                    message: "chat.tabs.chats.recent.userslist.user12.message",
                    status: 'online',
                    time: 'chat.tabs.chats.recent.userslist.user12.time'
                },
            ],
            newMessages: [],
            hideOptions: true,

            message: '',
            editedMessage: {},

            messageActions:[
                {
                    name: "Edit",
                    title: "Edit Message",
                    onlyMe: true,
                },
                {
                    name: "Delete",
                    title: "Delete Message",
                    onlyMe: true,
                },
            ],

        };
    },
    computed: {
        room() {
            return this.chatMemberList.find((room) => room.id === this.id) || {};
        },
        t() {
            return {
                ...locales,
                ...this.textMessages,
            };
        },
        convoList() {
            return store.getters.getMessages;
        },
        curConvoId() {
            return store.getters.getCurConvoId;
        },
        isMessageEmpty() {
            return !this.file && !this.message.trim();
        },
        inputDisabled() {
            return this.isMessageEmpty;
        },
    },
    methods: {
        sendMessage() {
            if (!this.message) return;

            this.messages.push({
                id: this.messages.length + 1,
                name: 'Patricia Smith',
                image: require('@/assets/images/users/avatar-1.jpg'),
                content: this.message,
                time: '10:02',
                align: 'right',
                is_user: true
            });

            let msg = this.message;

            if(!this.curConvoId){
                store.dispatch("createConvo").then( convoResp =>{
                    console.log("Response is: ", convoResp);
                    store.dispatch("sendMessage", {
                        query: msg, convoId: convoResp.conversation_id
                    }).then( resp =>{
                        console.log("Response is: ", resp);
                    }).catch(err=>{
                        console.log("Error is: ", err);
                    });
                })
            }

            this.$emit("sendMessage", this.message);
            this.resetMessage();
        },
        resizeTextarea() {
            const el = this.$refs["roomTextarea"];
            if (!el) return;
            const padding = window
                .getComputedStyle(el, null)
                .getPropertyValue("padding-top")
                .replace("px", "");
            el.style.height = 0;
            el.style.height = el.scrollHeight - padding * 2 + "px";
        },
        onChangeInput() {
            this.resizeTextarea();
            this.$emit("typingMessage", this.message);
        },
        resetMessage(disableMobileFocus = null) {
            this.$emit("typingMessage", null);
            this.resetTextareaSize();
            this.message = "";
            this.editedMessage = {};
            this.messageReply = null;
            setTimeout(() => this.focusTextarea(disableMobileFocus), 0);
        },
        focusTextarea() {
            this.$refs["roomTextarea"].focus();
        },
        resetTextareaSize() {
            if (!this.$refs["roomTextarea"]) return;
            this.$refs["roomTextarea"].style.height = "20px";
        },
        fetchConversations() {
            store.dispatch("getAllConvos");
        },

        addNewMessage(message) {
            this.newMessages.push(message);
            this.handleScroll();
        },
        handleScroll() {
            if (this.$refs.current.$el) {
                setTimeout(() => {
                    this.$refs.current.SimpleBar.getScrollElement().scrollTop =
                        this.$refs.current.SimpleBar.getScrollElement().scrollHeight + 1500;
                }, 500);
            }
        },
        messageActionHandler({ action, message }) {
            let self = this;
            switch (action.name) {
                case "Edit":
                    return this.editMessage(message);
                case "Delete":
                    self.messages.filter((item, index) => {
                        if (item.id === message.id) {
                            self.messages.splice(index, 1);
                        }
                    });
                    break;
                default:
                    return this.$emit("messageActionHandler", {
                        action,
                        message,
                    });
            }
        },
    },
    validations: {
        message: { required }
    }
}
</script>


<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}


.messages-container {
    padding: 0 5px 5px;
}

.room-footer {
    width: calc(100% - 1px);
    border-bottom-right-radius: 4px;
    z-index: 10;
}

.box-footer {
    display: flex;
    position: relative;
    background: var(--chat-footer-bg-color);
    padding: 10px 8px 10px;
}

.reply-container {
    display: flex;
    padding: 10px 10px 0 10px;
    background: var(--chat-content-bg-color);
    align-items: center;
    max-width: 100%;

    .reply-box {
        width: 100%;
        overflow: hidden;
        background: var(--chat-footer-bg-color-reply);
        border-radius: 4px;
        padding: 8px 10px;
        display: flex;
    }

    .reply-info {
        overflow: hidden;
    }

    .reply-username {
        color: var(--chat-message-color-reply-username);
        font-size: 12px;
        line-height: 15px;
        margin-bottom: 2px;
    }

    .reply-content {
        font-size: 12px;
        color: var(--chat-message-color-reply-content);
    }

    .icon-reply {
        margin-left: 10px;

        svg {
            height: 20px;
            width: 20px;
        }
    }

    .image-reply {
        max-height: 100px;
        margin-right: 10px;
    }
}

textarea {
    height: 20px;
    width: 100%;
    line-height: 20px;
    overflow: hidden;
    outline: 0;
    resize: none;
    border-radius: 20px;
    padding: 12px 16px;
    box-sizing: content-box;
    font-size: 16px;
    background: var(--chat-bg-color-input);
    color: var(--chat-color);
    caret-color: var(--chat-color-caret);
    border: var(--chat-border-style-input);

    &::placeholder {
        color: var(--chat-color-placeholder);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.icon-textarea {
    display: flex;
    margin: 0px 0 0 5px;

    svg,
    .wrapper {
        margin: 0 7px;
    }
}

.image-container {
    position: absolute;
    max-width: 25%;
    left: 16px;
    top: 18px;
}

.image-file {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 30px;

    img {
        border-radius: 7px;
        width: 100%;
        max-width: 150px;
        max-height: 100%;
        margin: 12px 0 0 12px;
    }
}

.icon-image {
    position: absolute;
    z-index: 10;
}

.file-container {
    display: flex;
    align-items: center;
    width: calc(100% - 75px);
    height: 20px;
    padding: 12px 0;
    box-sizing: content-box;
    background: var(--chat-bg-color-input);
    border: var(--chat-border-style-input);
    border-radius: 20px;
}

.file-container-edit {
    width: calc(100% - 109px);
}

.file-message {
    max-width: calc(100% - 75px);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.icon-file {
    display: flex;
    margin: 0 8px 0 15px;
}

.icon-remove {
    margin-left: 8px;

    svg {
        height: 18px;
        width: 18px;
    }
}

.send-disabled,
.send-disabled svg {
    cursor: none !important;
    pointer-events: none !important;
    transform: none !important;
}

.messages-hidden {
    opacity: 0;
}

@media only screen and (max-width: 768px) {
    .box-footer {
        border-top: var(--chat-border-style-input);
        padding: 7px 2px 7px 7px;
    }

    textarea {
        padding: 7px;
        line-height: 18px;

        &::placeholder {
            color: transparent;
        }
    }

    .icon-textarea {
        margin: 6px 0 0 5px;

        svg,
        .wrapper {
            margin: 0 5px;
        }
    }

    .image-container {
        top: 10px;
        left: 10px;
    }

    .image-file img {
        transform: scale(0.97);
    }

    .room-footer {
        width: 100%;
    }

    .file-container {
        padding: 7px 0;

        .icon-file {
            margin-left: 10px;
        }
    }

    .reply-container {
        padding: 5px 8px;
    }
}
</style>

